module.exports = __webpack_public_path__ + "static/media/blackEquity.5b114367.png";